// test277
(277 && 0);
